export class ResourcePending {}
